import apisauce from "apisauce";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import webPackage from "../../../package.json";
import { errorMsg, successMsg } from "./notification";

async function getLoginToken() {
  const token = await firebase.auth().currentUser.getIdToken(true);
  if (token) {
    api.setHeader("X-Authorization-Firebase", token);
  }
}

const api = apisauce.create({
  baseURL: process.env.REACT_APP_SERVER,
  headers: {
    "Content-Type": "application/json",
    appType: "Web",
    version: webPackage.version,
    timezone: new Date().getTimezoneOffset(),
  },
  timeout: 10000,
});

const create = () => {
  const autoAuthenticate = async () => {
    setInterval(() => {
      getLoginToken();
    }, 20 * 60 * 1000);
    await getLoginToken();
    return api.get("/auth/userInfo");
  };

  const getAllDevices = () => api.get("/user-controller/list");

  const getWeather = (data) => api.get(`/auth/weather/${data.deviceId}`);

  const getAllSchedules = (data) =>
    api.get(`/schedules/list?deviceId=${data.deviceId}`);

  const getLogs = (data) =>
    api.get(`/watering/logs?deviceId=${data.deviceId}&date=${data.date}`);

  const getZones = (data) => api.get(`/zones/all?deviceId=${data.deviceId}`);

  const getZoneImages = (data) =>
    api.get(`/zone/fetch/images?deviceId=${data.deviceId}`);

  const getZoneFields = () => api.get("/zones/setup-config");

  const runSchedule = (data) => api.post("/watering/start-multiple-run", data);

  const lastWatered = (data) =>
    api.get(`/watering/lastWatered?deviceId=${data.deviceId}`);

  const upcomingWatering = (data) =>
    api.get(`/schedules/upcoming?deviceId=${data.deviceId}`);

  const selectDevice = (device) => api.post("/device/select", device);

  const fetchCalendarDates = (data) =>
    api.get(`/schedules/dates?deviceId=${data.deviceId}`);

  const fetchScheduleForDay = (data) =>
    api.get(
      `/schedules/by-date?deviceId=${data.deviceId}&date=${data.timestamp}`
    );

  const currentWatering = () => api.get("/watering/current");

  const updateZone = (data) => api.put("/zones/update", data);

  const startQuickRun = (data) => api.post("/watering/start-quick-run", data);

  const startMultipleQuickRun = (data) =>
    api.post("/watering/start-multiple-run", data);

  const stopWatering = (data) => api.post("/watering/stop", data);

  const skipWatering = (data) => api.post("/watering/skip", data);

  const editUserInfo = (data) => api.put("/auth/editUser", data);

  const editDeviceInfo = (data) => api.put("/user-controller/update", data);

  const coldResetController = (data) =>
    api.post("/device/accessPointMode", data);

  const factoryResetController = (data) => api.post("/device/delete", data);

  const registerDevice = (data) => api.put("/auth/device", data);

  const createSchedule = (data) => api.post("/schedules/add", data);

  const updateSchedule = (data) => api.put("/schedules/update", data);

  const deleteSchedule = (data) => api.delete("/schedules/delete", data);

  const createCalender = (data) =>
    api.post(
      `watering/update-calendar?serialNumber=${data.serialNumber}`,
      data.data
    );

  const updateFirmware = (data) =>
    api.get(`/ota/request-firmware-upgrade?deviceId=${data}`);

  const fetchUsers = () => api.get(`/admin/users/list`);

  const fetchControllers = () => api.get(`/admin/controllers/list`);
  const fetchUserControllers = () => api.get(`/admin/user-controllers/list`);
  const updateOta = (data) => api.put(`/admin/user-controllers/update`, data);
  const addController = (data) => api.post(`/admin/controllers/add`, data);
  const updateController = (data) => api.put(`/admin/controllers/update`, data);
  const adminFactoryResetController = (data) =>
    api.post(`/admin/user-controllers/reset`, data);
  const fetchInvoice = () => api.get(`/admin/invoice/list`);
  const acceptOwnershipInvite = (data) =>
    api.post(`/auth/accept-ownership`, data);
  const sendMqttMessage = (data) =>
    api.post(`/admin/user-controllers/send-mqtt-message`, data);
  return {
    api,
    autoAuthenticate,
    getAllDevices,
    getAllSchedules,
    getLogs,
    getZones,
    getZoneFields,
    runSchedule,
    lastWatered,
    upcomingWatering,
    selectDevice,
    fetchCalendarDates,
    fetchScheduleForDay,
    currentWatering,
    updateZone,
    startQuickRun,
    startMultipleQuickRun,
    editUserInfo,
    editDeviceInfo,
    getZoneImages,
    coldResetController,
    factoryResetController,
    createSchedule,
    updateSchedule,
    createCalender,
    deleteSchedule,
    registerDevice,
    stopWatering,
    skipWatering,
    updateFirmware,
    fetchUsers,
    fetchControllers,
    fetchUserControllers,
    updateOta,
    addController,
    updateController,
    fetchInvoice,
    acceptOwnershipInvite,
    adminFactoryResetController,
    getWeather,
    sendMqttMessage,
  };
};

export const responseParser = (
  response,
  error = "Error",
  success = "",
  showError = true,
  showSuccess = false
) => {
  if (response.ok) {
    const successMsgText = success || response?.data?.message;
    if (successMsgText && showSuccess) {
      successMsg("Success", successMsgText);
    }
    return response.data.data;
  }
  if (showError) errorMsg(error, response?.data?.error || "Internal Error");
  return false;
};

export default { create };
